if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.productSlider.dataset.hideVariants === 'true';

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.renderVariantInfo();
      this.updateOther();

      // Force reorder on every variant change
      this.setImageSetMedia();

      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }

    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          const targetFieldset = fieldsets_array[i];
          if (!targetFieldset) return;

          const selectEl = targetFieldset.querySelector('select');
          if (selectEl) {
            selectEl.value = option;
          } else {
            const inputs = targetFieldset.querySelectorAll('input');
            if (inputs.length) {
              // Compare values directly instead of building a CSS attribute
              // selector from `option` — option values can contain characters
              // like `"` (e.g. 36"x72") that break `input[value="${option}"]`
              // and throw, aborting the rest of onVariantChange().
              const match = Array.from(inputs).find((input) => input.value === option);
              if (match) match.checked = true;
            }
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      this.setActiveMedia(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
    }

    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);
          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        if (this.thumbnails) {
          let currentThumb = this.thumbnails.querySelector('.product-thumbnail.is-initial-selected');
          if (currentThumb) {
            currentThumb.classList.remove('is-initial-selected');
          }
          let activeThumb = this.thumbnails.querySelector(thumbId);
          if (activeThumb) {
            activeThumb.classList.add('is-initial-selected');
          }
        }
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant) return;

      const url = new URL(window.location.href);

      url.searchParams.set('variant', this.currentVariant.id);

      window.history.replaceState({}, '', url.toString());
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`
      ];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    renderVariantInfo() {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }

          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');

      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('loading');
        if (productTemplate?.includes('pre-order')) {
          addButtonText.textContent = window.theme.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.theme.variantStrings.unavailable;
      addButton.classList.add('sold-out');
      if (price) price.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;
      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().trim();
    }

    setImageSet() {
      if (!this.productSlider) return;

      // Map of normalized color names → their alt-text keys used in image groups
      // These must match exactly what you put after # in the image alt text
      const COLOR_MAP = {
        'teal':             'teal',
        'beige':            'beige',
        'silver':           'silver',
        'dark grey':        'dark grey',
        'medium blue':      'medium blue',
        'sky blue':         'sky blue',
        'burgundy':         'burgundy',
        'peach':            'peach',
        'white':            'white',
        'chocolate brown':  'chocolate brown'
      };

      var slideGroups = new Set();
      this.productSlider.querySelectorAll('[data-group]').forEach(function(el) {
        slideGroups.add(el.getAttribute('data-group').toLowerCase().trim());
      });

      if (!slideGroups.size) return;

      var fieldsets = Array.from(this.querySelectorAll('fieldset'));
      var self = this;

      fieldsets.forEach(function(fieldset, i) {
        var matched = false;

        fieldset.querySelectorAll('input').forEach(function(input) {
          var val = input.value.toLowerCase().trim();
          // Check direct match OR mapped match
          if (slideGroups.has(val)) matched = true;
          if (COLOR_MAP[val] && slideGroups.has(COLOR_MAP[val])) matched = true;
        });

        var select = fieldset.querySelector('select');
        if (select) {
          Array.from(select.options).forEach(function(opt) {
            var val = opt.value.toLowerCase().trim();
            if (slideGroups.has(val)) matched = true;
            if (COLOR_MAP[val] && slideGroups.has(COLOR_MAP[val])) matched = true;
          });
        }

        if (matched) {
          self.imageSetIndex = 'option' + (i + 1);
          self.dataset.imageSetIndex = self.imageSetIndex;
          setTimeout(function() {
            self.setImageSetMedia();
          }, 150);
        }
      });
    }

    setImageSetMedia() {
  if (!this.imageSetIndex) return;

  const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
  const selectedVariantValue = this.options[optionPosition].toLowerCase().trim();

  const sliderEl = this.productWrapper.querySelector('.product-images');
  if (!sliderEl) return;

  // ── 1. Collect and separate SLIDES based on alt text ────────────────────────────
  const allSlides = Array.from(sliderEl.querySelectorAll('.product-images__slide'));
  const matchedSlides = [];      // Slides with matching data-group (variant images)
  const noAltSlides = [];        // Slides WITHOUT alt text (images without alt attribute or empty alt)
  const otherSlides = [];        // Other slides (non-matching, but have alt text)

  allSlides.forEach((slide) => {
    // Check if slide has alt text
    const imgElement = slide.querySelector('img');
    let hasAltText = false;

    if (imgElement) {
      const altValue = imgElement.getAttribute('alt');
      hasAltText = altValue && altValue.trim() !== '';
    }

    const raw = slide.getAttribute('data-group');
    const group = raw ? raw.toLowerCase().trim() : null;

    // Match: group equals selected value, OR selected value contains group,
    // OR group contains selected value
    const isMatch = group && (
      group === selectedVariantValue ||
      selectedVariantValue.includes(group) ||
      group.includes(selectedVariantValue)
    );

    if (isMatch) {
      matchedSlides.push(slide);
    } else if (!hasAltText) {
      // Images without alt text go here (regardless of group)
      noAltSlides.push(slide);
    } else {
      otherSlides.push(slide);
    }
  });

  // ── 2. Hide ALL slides first ─────────────────────────
  allSlides.forEach(slide => {
    slide.style.display = 'none';
    slide.classList.remove('is-active');
  });

  // ── 3. Show matched variant slides (top section) ─────
  matchedSlides.forEach(slide => {
    slide.style.display = '';
    slide.classList.add('is-active');
  });

  // ── 4. Show no-alt-text slides (bottom section) ──────
  noAltSlides.forEach(slide => {
    slide.style.display = '';
    slide.classList.add('is-active');
  });

  // Note: otherSlides (with alt text but not matching variant) remain hidden

  // ── 5. Reorder slides: matched first, then no-alt slides, then others (hidden) ──
  const slideFragment = document.createDocumentFragment();
  matchedSlides.forEach(s => slideFragment.appendChild(s));
  noAltSlides.forEach(s => slideFragment.appendChild(s));
  otherSlides.forEach(s => slideFragment.appendChild(s));
  sliderEl.appendChild(slideFragment);

  // ── 6. Collect and separate THUMBNAILS based on alt text ────────────────────────
  const thumbContainer = this.productWrapper.querySelector('.product-thumbnail-container');
  let matchedThumbs = [];
  let noAltThumbs = [];
  let otherThumbs = [];

  if (thumbContainer) {
    const allThumbs = Array.from(thumbContainer.querySelectorAll('.product-thumbnail'));

    allThumbs.forEach((thumb) => {
      // Check if thumbnail image has alt text
      const thumbImg = thumb.querySelector('img');
      let hasAltText = false;

      if (thumbImg) {
        const altValue = thumbImg.getAttribute('alt');
        hasAltText = altValue && altValue.trim() !== '';
      }

      const raw = thumb.getAttribute('data-group');
      const group = raw ? raw.toLowerCase().trim() : null;
      const isMatch = group && (
        group === selectedVariantValue ||
        selectedVariantValue.includes(group) ||
        group.includes(selectedVariantValue)
      );

      if (isMatch) {
        matchedThumbs.push(thumb);
      } else if (!hasAltText) {
        noAltThumbs.push(thumb);
      } else {
        otherThumbs.push(thumb);
      }
    });

    // Hide all thumbnails first
    allThumbs.forEach(thumb => {
      thumb.style.display = 'none';
      thumb.classList.remove('is-active');
    });

    // Show matched thumbnails
    matchedThumbs.forEach(thumb => {
      thumb.style.display = '';
      thumb.classList.add('is-active');
    });

    // Show no-alt-text thumbnails
    noAltThumbs.forEach(thumb => {
      thumb.style.display = '';
      thumb.classList.add('is-active');
    });

    // Reorder thumbnails: matched first, then no-alt, then others (hidden)
    const thumbFragment = document.createDocumentFragment();
    matchedThumbs.forEach(t => thumbFragment.appendChild(t));
    noAltThumbs.forEach(t => thumbFragment.appendChild(t));
    otherThumbs.forEach(t => thumbFragment.appendChild(t));
    thumbContainer.appendChild(thumbFragment);

    // Reset is-initial-selected — first visible thumb becomes selected
    const allVisibleThumbs = [...matchedThumbs, ...noAltThumbs];
    allThumbs.forEach(t => t.classList.remove('is-initial-selected'));
    if (allVisibleThumbs.length > 0) {
      allVisibleThumbs[0].classList.add('is-initial-selected');
    }
  }

  // ── 7. Get visible slides for Flickity ───────────────────────────────
  const visibleSlides = [...matchedSlides, ...noAltSlides];

  // If no visible slides, create a placeholder
  if (visibleSlides.length === 0) {
    const placeholder = document.createElement('div');
    placeholder.className = 'product-images__slide is-active';
    placeholder.style.minHeight = '300px';
    placeholder.innerHTML = '<div class="product-single__media" style="text-align:center;padding:100px 20px;">No images available for this variant</div>';
    sliderEl.innerHTML = '';
    sliderEl.appendChild(placeholder);
    visibleSlides.push(placeholder);
  }

  // ── 8. Get the ProductSlider custom element instance ──────────
  const productSliderInstance = sliderEl;

  // ── 9. Destroy existing Flickity fully ────────────────────────
  if (sliderEl.flkty) {
    sliderEl.flkty.destroy();
    sliderEl.flkty = null;
  }
  if (productSliderInstance.eventController) {
    productSliderInstance.eventController.abort();
    productSliderInstance.eventController = null;
  }

  // ── 10. Refresh thumbnail NodeList BEFORE reinit ───────────────
  if (thumbContainer) {
    productSliderInstance.thumbnails = thumbContainer.querySelectorAll('.product-thumbnail.is-active');
  }

  // ── 11. Reinit Flickity with only visible slides ────────────────
  const flickityOptions = {
    wrapAround: true,
    pageDots: false,
    contain: true,
    adaptiveHeight: true,
    initialIndex: 0,
    prevNextButtons: false,
    fade: false,
    cellSelector: '.product-images__slide.is-active'
  };

  sliderEl.flkty = new Flickity(sliderEl, flickityOptions);
  productSliderInstance.flkty = sliderEl.flkty;
  productSliderInstance.selectedIndex = 0;

  // ── 12. Re-attach all events ────────────────────────────────────
  productSliderInstance.setupEvents();
  productSliderInstance.setupZoomListeners();

  // ── 13. Refresh thumbnails click events ────────────────────────
  if (thumbContainer) {
    const currentThumbs = thumbContainer.querySelectorAll('.product-thumbnail.is-active');
    currentThumbs.forEach((thumbnail) => {
      thumbnail.removeEventListener('click', productSliderInstance.thumbnailClick);
      thumbnail.addEventListener('click', () => {
        productSliderInstance.thumbnailClick(thumbnail);
      });
    });
  }
}
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }

    updateVariantText() {}
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      if (this.thumbnail_container) {
        this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active');
      }
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        // Always open on the first visible slide (admin media order),
        // never on the selected variant's featured media.
        initialIndex: 0,
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };

      if (this.classList.contains('product-quick-images')) {
        this.options.cellAlign = 'left';
        this.options.pageDots = false;
        this.options.freeScroll = true;
        this.options.wrapAround = false;
      }
    }

    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;
      this.syncInitialThumb();
      this.setupEvents();
      this.setupZoomListeners();
    }

    reInit() {
      if (this.eventController) {
        this.eventController.abort();
      }
      this.flkty.destroy();
      this.setOptions();
      this.flkty = new Flickity(this, this.options);
      this.setupEvents();
      this.selectedIndex = this.flkty.selectedIndex;
      this.setupZoomListeners();
    }

    /**
     * Guarantees the highlighted thumbnail matches the slide Flickity
     * actually opened on. Covers the case where the first thumbnail is
     * hidden (hide_variants) and Liquid's is-initial-selected lands on
     * an inactive element.
     */
    syncInitialThumb() {
      if (!this.thumbnail_container) return;

      const activeThumbs = Array.from(
        this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active')
      );
      if (!activeThumbs.length) return;

      const cell = this.flkty.cells[this.flkty.selectedIndex];
      const slideMediaId = cell ? cell.element.getAttribute('data-media-id') : null;

      let target = null;
      if (slideMediaId) {
        target = this.thumbnail_container.querySelector(`#Thumb-${slideMediaId}`);
      }
      if (!target || !target.classList.contains('is-active')) {
        target = activeThumbs[0];
      }

      activeThumbs.forEach((t) => t.classList.remove('is-initial-selected'));
      target.classList.add('is-initial-selected');
    }

    setupEvents() {
      this.eventController = new AbortController();
      const signal = this.eventController.signal;

      if (this.prev_button) {
        this.prev_button.addEventListener('click', () => {
          this.flkty.previous();
        }, { signal });
        this.prev_button.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        }, { signal });
      }
      if (this.next_button) {
        this.next_button.addEventListener('click', () => {
          this.flkty.next();
        }, { signal });
        this.next_button.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        }, { signal });
      }

      this.querySelectorAll('.product-single__media-external-video--play button').forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.closest('.product-single__media-external-video--play').setAttribute('hidden', '');
        }, { signal });
      });

      this.flkty.on('settle', (index) => {
        this.selectedIndex = index;
      });

      this.flkty.on('change', (index) => {
        const prevCell = this.flkty.cells[this.selectedIndex];
        const currCell = this.flkty.cells[index];

        if (!currCell) return;

        const previous_slide = prevCell ? prevCell.element : null;
        const previous_media = previous_slide ? previous_slide.querySelector('.product-single__media') : null;
        const slide = currCell.element;
        const media = slide.querySelector('.product-single__media');

        if (this.thumbnail_container) {
          // Re-query fresh thumbs - only visible (is-active) thumbnails
          const freshThumbs = Array.from(this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active'));

          freshThumbs.forEach((item) => {
            item.classList.remove('is-initial-selected');
          });

          // Match thumbnail to slide by data-media-id
          const slideMediaId = slide.getAttribute('data-media-id');
          let matchedThumb = null;

          if (slideMediaId) {
            matchedThumb = this.thumbnail_container.querySelector(`#Thumb-${slideMediaId}`);
          }

          // Fallback: use position index within visible thumbs
          if (!matchedThumb) {
            matchedThumb = freshThumbs[index] || freshThumbs[0];
          }

          if (matchedThumb) {
            matchedThumb.classList.add('is-initial-selected');
            this.scrollToThumbnail(matchedThumb);
          }
        }

        this.pauseMedia(previous_media);

        if (media && media.classList.contains('product-single__media-model')) {
          this.setDraggable(false);
        } else {
          this.setDraggable(true);
        }
      });

      let scrollbar = document.querySelector('.product-quick-images__scrollbar>div');
      if (scrollbar) {
        this.flkty.on('scroll', function (progress) {
          progress = Math.max(0, Math.min(1, progress));
          scrollbar.style.transform = 'scaleX(' + progress + ')';
        });
      }

      if (this.thumbnail_container) {
        // Re-query fresh thumbnails for click events - only visible ones
        const currentThumbs = this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active');
        currentThumbs.forEach((thumbnail) => {
          // Remove existing listener to avoid duplicates, then add fresh one
          thumbnail.removeEventListener('click', this.thumbnailClick);
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail);
          }, { signal });
        });
      }
    }

    scrollToThumbnail(thumb) {
      requestAnimationFrame(() => {
        if (!thumb || thumb.offsetParent === null) return;
        const windowHalfHeight = thumb.offsetParent.clientHeight / 2;
        const windowHalfWidth  = thumb.offsetParent.clientWidth / 2;
        thumb.parentElement.scrollTo({
          left: thumb.offsetLeft - windowHalfWidth + thumb.clientWidth / 2,
          top:  thumb.offsetTop  - windowHalfHeight + thumb.clientHeight / 2,
          behavior: 'smooth'
        });
      });
    }

    pauseMedia(media) {
      if (!media) return;
      if (media.classList.contains('product-single__media-external-video')) {
        if (media.dataset.provider === 'youtube') {
          media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: 'command', func: 'pauseVideo', args: ''
          }), '*');
        } else if (media.dataset.provider === 'vimeo') {
          media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: 'pause'
          }), '*');
        }
        let playBtn = media.querySelector('.product-single__media-external-video--play');
        if (playBtn) playBtn.removeAttribute('hidden');
      } else if (media.classList.contains('product-single__media-native-video')) {
        media.querySelector('video').pause();
      }
    }

    thumbnailClick(thumbnail) {
      // Clear all is-initial-selected from visible thumbnails only
      if (this.thumbnail_container) {
        this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active').forEach(el => {
          el.classList.remove('is-initial-selected');
        });
      }
      thumbnail.classList.add('is-initial-selected');

      // Match by data-media-id on the slide
      const thumbId = thumbnail.id;
      if (thumbId) {
        const mediaId = thumbId.replace(/^Thumb-/, '');
        const cellIndex = this.flkty.cells.findIndex(cell =>
          cell.element.getAttribute('data-media-id') === mediaId
        );
        if (cellIndex > -1) {
          this.flkty.select(cellIndex);
          return;
        }
      }

      // Fallback: match by position in visible thumbs
      const activeThumbs = Array.from(
        this.thumbnail_container
          ? this.thumbnail_container.querySelectorAll('.product-thumbnail.is-active')
          : []
      );
      const index = activeThumbs.indexOf(thumbnail);
      if (index > -1) {
        this.flkty.select(index);
      }
    }

    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }

    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }

    setupZoomListeners() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) return;
      this.setEventListeners();
    }

    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll('.product-images__slide.is-active .product-single__media-image')
      );
      return this.activeImages.map((item) => {
        let index = Array.from(item.parentNode.parentNode.children).indexOf(item.parentNode);
        let activelink = item.querySelector('.product-single__media-zoom');
        activelink.dataset.index = index;
        return {
          src:  activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w:    activelink.dataset.w,
          h:    activelink.dataset.h
        };
      });
    }

    setEventListeners() {
      if (this.zoomController) {
        this.zoomController.abort();
      }
      this.zoomController = new AbortController();
      const zoomSignal = this.zoomController.signal;

      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: false,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected');
          const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          const rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      };

      this.links.forEach((link) => {
        link.addEventListener('click', (e) => this.zoomClick(e, link), { signal: zoomSignal });
      });
    }

    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(
          this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions
        );
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = { top: 50, bottom: 50 };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }

    disconnectedCallback() {
      if (this.eventController) this.eventController.abort();
      if (this.zoomController)  this.zoomController.abort();
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    }
  }

  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this._onSubmit = this.onSubmitHandler.bind(this);
        this.form.addEventListener('submit', this._onSubmit);
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    disconnectedCallback() {
      if (this._onSubmit && this.form) {
        this.form.removeEventListener('submit', this._onSubmit);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) return;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }
            this.handleErrorMessage(response.description);
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [
        { id: 'Cart',              section: 'main-cart',    selector: '.thb-cart-form' },
        { id: 'Cart-Drawer',       section: 'cart-drawer',  selector: '.cart-drawer'   },
        { id: 'cart-drawer-toggle',section: 'cart-bubble',  selector: '.thb-item-count'}
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) return;
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section], section.selector
        );
        const cartEl = document.getElementById('Cart');
        if (cartEl && cartEl.renderContents) cartEl.renderContents(parsedState);
      });

      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        OverlayManager.close(product_drawer);
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.animations_enabled =
        document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }

    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }

    setupToggle() {
      const button  = this.querySelector('.product-add-to-cart-sticky--inner');
      const content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => { button.classList.add('sticky-open'); },
          onReverseComplete: () => { button.classList.remove('sticky-open'); }
        });
        tl
          .set(content, { display: 'block', height: 'auto' }, 'start')
          .from(content, { height: 0, duration: 0.25 }, 'start+=0.001');

        button.addEventListener('click', function () {
          if (tl.reversed()) { tl.play(); } else { tl.reverse(); }
          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    setupObservers() {
      let _this = this;
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.target === footer) {
            if (entry.intersectionRatio > 0) {
              _this.classList.remove('sticky--visible');
            } else if (entry.intersectionRatio == 0 && _this.formPassed) {
              _this.classList.add('sticky--visible');
            }
          }
          if (entry.target === form) {
            let boundingRect = form.getBoundingClientRect();
            if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
              _this.formPassed = true;
              _this.classList.add('sticky--visible');
            } else if (entry.intersectionRatio === 1) {
              _this.formPassed = false;
              _this.classList.remove('sticky--visible');
            }
          }
        });
      }, { threshold: [0, 1] });

      const form   = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer');
      _this.formPassed = false;
      this._observer = observer;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== 'undefined') {
  addIdToRecentlyViewed();
}